import React from 'react';

import './Breadcrumbs.scss';
import { econdaClickEvent } from '../../Econda';
import useTranslation from '../../features/translation/hooks/useTranslation';
import { RequestHandler } from '../../app/RequestHandler';
import useFoXPresence from '../Headline/hooks/useFoXHeadline';

// TO-DO: Add Breadcrumbs.test.tsx to test the behavior

enum TranslationKeys {
  HOME = 'home',
  ENGINEERING_TOOLS = 'engineeringTools',
  CONNECTIVITY_FINDER_TOOL = 'headlineName',
}

function Breadcrumbs() {
  const t = useTranslation();
  const { country, language } = new RequestHandler();
  const { hasFoXBreadcrumbs } = useFoXPresence();

  const homeUrl = `${process.env.REACT_APP_FESTO_URL}${country}/${language}/`;
  const engineeringToolsUrl = `${process.env.REACT_APP_FESTO_URL}${country}/${language}/e/products/digital-engineering-tools-id_650881/`;

  function onBreadcrumbsHomeClick() {
    econdaClickEvent('connectivity finder', 'general', 'breadcrumbs', 'home');
  }

  function onBreadcrumbsEngineeringToolsClick() {
    econdaClickEvent('connectivity finder', 'general', 'breadcrumbs', 'engineering tools');
  }

  if(hasFoXBreadcrumbs) return <></>

  return (
    <div className="container-fluid">
      <div className="fwe-breadcrumbs-container fwe-d-flex">
        <a
          className="breadcrumbs-link"
          target={'_blank'}
          rel="noreferrer"
          onClick={onBreadcrumbsHomeClick}
          href={homeUrl}
        >
          {t(TranslationKeys.HOME)}
        </a>
        <i className={`fwe-icon fwe-icon-arrows-right-2`} />
        <a
          className="breadcrumbs-link"
          target={'_blank'}
          rel="noreferrer"
          onClick={onBreadcrumbsEngineeringToolsClick}
          href={engineeringToolsUrl}
        >
          {t(TranslationKeys.ENGINEERING_TOOLS)}
        </a>
        <i className={`fwe-icon fwe-icon-arrows-right-2`} />
        <span>{t(TranslationKeys.CONNECTIVITY_FINDER_TOOL)}</span>
      </div>
      <div className="show-only-on-375 container-fluid">
        <i className="fwe-icon fwe-icon-arrows-left-2"></i>
        <a className="tool-link" onClick={onBreadcrumbsEngineeringToolsClick} href={engineeringToolsUrl}>
          {t(TranslationKeys.ENGINEERING_TOOLS)}
        </a>
      </div>
    </div>
  );
}

export default Breadcrumbs;
